import { lazy, Suspense } from 'react';

import { Loading } from '../../components/ui.jsx';

/**
 * Email in the web app: mail settings (Cloudflare SMTP, test email), templates with a live preview,
 * the email log, bounces and complaints, the admin client page's Emails tab, the client's own email
 * history and the public unsubscribe page.
 */
const page = (load, name) => () => load().then((m) => ({ Component: m[name] }));
const settings = () => import('./MailSettings.jsx');
const templates = () => import('./Templates.jsx');
const log = () => import('./MailLog.jsx');
const suppressions = () => import('./Suppressions.jsx');
const unsubscribe = () => import('./Unsubscribe.jsx');

const ClientEmailsTab = (() => {
  const Lazy = lazy(() => log().then((m) => ({ default: m.ClientEmailsTab })));
  return function Deferred(props) {
    return (
      <Suspense fallback={<Loading />}>
        <Lazy {...props} />
      </Suspense>
    );
  };
})();

export default {
  name: 'mail',
  publicRoutes: [{ path: 'unsubscribe', lazy: page(unsubscribe, 'Unsubscribe') }],
  clientRoutes: [{ path: 'account/emails', lazy: page(log, 'ClientEmails') }],
  adminRoutes: [
    { path: 'mail/settings', lazy: page(settings, 'MailSettings') },
    { path: 'mail/templates', lazy: page(templates, 'Templates') },
    { path: 'mail/templates/:key', lazy: page(templates, 'TemplateEditor') },
    { path: 'mail/log', lazy: page(log, 'MailLog') },
    { path: 'mail/log/:uuid', lazy: page(log, 'MailLogDetail') },
    { path: 'mail/suppressions', lazy: page(suppressions, 'Suppressions') },
  ],
  clientNav: [{ key: 'emails', to: '/account/emails', order: 92, auth: true }],
  adminNav: [
    {
      section: 'system',
      to: '/admin/mail/settings',
      label: 'Mail settings',
      permission: 'admin.settings.mail.read',
      order: 30,
    },
    {
      section: 'system',
      to: '/admin/mail/templates',
      label: 'Email templates',
      permission: 'admin.email.templates',
      order: 31,
    },
    { section: 'system', to: '/admin/mail/log', label: 'Email log', permission: 'admin.email.read', order: 32 },
    {
      section: 'system',
      to: '/admin/mail/suppressions',
      label: 'Bounces',
      permission: 'admin.email.read',
      order: 33,
    },
  ],
  adminClientTabs: [
    { key: 'emails', label: 'Emails', order: 70, permission: 'admin.email.read', Component: ClientEmailsTab },
  ],
};
